import captureException from 'src/common/utils/captureException';
import { SessionData } from '../types';

const getSessionData = (returnUrl: string): SessionData | null => {
  if (typeof window === 'undefined') return null;

  try {
    const url = new URL(returnUrl, window.location.origin);
    const searchParams = new URLSearchParams(url.search);

    // Get the sessionKey parameter
    const sessionKey = searchParams.get('sessionKey');
    if (!sessionKey) return null;

    // Get session data from sessionStorage
    const sessionData = sessionStorage.getItem(sessionKey);
    if (!sessionData) return null;

    return JSON.parse(sessionData) as SessionData;
  } catch (error) {
    captureException(error, {
      extra: {
        returnUrl,
      },
    });
    return null;
  }
};

export default getSessionData;
